<template>
	<div class="browsinghistory">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>浏览记录</span>
			<div style="margin-top: 0.25rem;" @click="tedefr = !tedefr">
				<van-icon style="position: relative; top: 0.125rem;" name="edit" />
			</div>
		</div>
		<div class="block">
			<div class="block_s">
				<van-checkbox-group v-model="result" ref="checkboxGroup">
					<div v-for="(item,index) in seelist" :key="index">
						<div class="tiem">{{item.day}}</div>
						<div class="Delivery">
							<div class="jilu " v-for="(items,index) in item.list" :key="index">
								<van-checkbox v-show="tedefr==true" checked-color="#F1452F" :name="items.id" icon-size="16px"></van-checkbox>
								<div class="browse_action">
									<img :src="items.goods.image" @click="goDetail(items.goods_id,items.category_id)" />
									<div style="margin-left: 0.5rem; text-align: left; width: 70%;" @click="goDetail(items.goods_id,items.goods.category_id)">
										<div class="browse_name">{{items.goods.title}}</div>
										<div class="search">
											<span v-if="items.goods.category_id == 2" class="limit_time" :data-last_time="items.goods.last_time" style="font-size: 12px; color: #F1452F;"></span>
											<span class="period" v-if="items.goods.category_id == 1">工期{{items.goods.goods_work}}天</span>
											<div class="iconsont" v-if="items.goods.category_id == 1">
												<van-rate :value="items.goods.hot_num" size="14px" color="#F1452F" bind:change="onChange" />
											</div>
										</div>
										<div>
											<span v-if="items.goods.category_id == 1" class="type">品牌租赁</span>
											<span v-if="items.goods.category_id == 2" class="type">限时抢购</span>
											<span v-if="items.goods.category_id == 3" class="type">精品二手</span>
											<div v-if="items.goods.category_id == 1" class="Price">租金<span style="font-size: 18px;">￥{{items.goods.price}}</span>/月起</div>
											<div v-if="items.goods.category_id == 2" class="Price">抢购价<span style="font-size: 18px;">￥{{items.goods.price}}</span></div>
											<div v-if="items.goods.category_id == 3" class="Price"><span style="font-size: 18px;">￥{{items.goods.price}}</span></div>
										</div>

									</div>
								</div>
							</div>
						</div>
					</div>
				</van-checkbox-group>
			</div>
		</div>
		<div class="settle" v-if="tedefr==true">
			<van-button type="primary" color="#F1452F" size="mini" round @click="checkAll" class="shanchubu">全选</van-button>
			<van-button type="default" color="#F1452F" size="mini" round @click="deletes" class="shanchubu">删除</van-button>
		</div>
	</div>
</template>

<script>
	import Footbar from '@/components/footbar';

	export default {
		data() {
			return {
				checked: [],
				seelist: [],
				tedefr: false,
				result: [],
				actEndTimeList: [],
				timer: ''
			}
		},
		created() {
			this.getseelist() // 获取浏览记录		
		},
		mounted() {
			var that = this;
			setTimeout(function() {
				that.run()
			}, 1000);
		},
		methods: {
			// 获取浏览记录
			getseelist() {
				this.$axios.post(baseUrl + '/mobile/Base/browseList', {
					token: localStorage.getItem('Authorization')
				}).then((res) => {
					this.seelist = res.data.data

				}).catch((err) => {
					console.log(err);
				});
			},
			//跳转详情
			goDetail(ids, category_id) {
				if (category_id == 2) {
					this.$router.push({
						path: '/limitDetail',
						query: {
							id: ids
						}
					})
				} else {
					this.$router.push({
						path: '/Detail',
						query: {
							id: ids
						}
					})
				}

			},
			checkAll() {
				this.$refs.checkboxGroup.toggleAll(true);
			},
			deletes() {
				if (this.result != []) {
					this.$dialog.confirm({
						message: '您确定要删除吗？'
					}).then(() => {
						this.$axios.post(baseUrl + '/mobile/Base/browseDel', {
							token: localStorage.getItem('Authorization'),
							id: this.result
						}).then((res) => {
							this.$toast("删除成功");
							this.getseelist() // 获取浏览记录
						}).catch((err) => {
							console.log(err);
						});
					});
				}
			},
			showtime(time) {
				var leftd = Math.floor(time / 86400), //计算天数
					lefth = Math.floor(time % 86400 / 3600), //计算小时数
					leftm = Math.floor(time % 86400 % 3600 / 60), //计算分钟数
					lefts = Math.floor(time % 86400 % 3600 % 60); //计算秒数
				if (leftd < 10) {
					leftd = '0' + leftd;
				}
				if (lefth < 10) {
					lefth = '0' + lefth;
				}
				if (leftm < 10) {
					leftm = '0' + leftm;
				}
				if (lefts < 10) {
					lefts = '0' + lefts;
				}
				return '距下架：' + leftd + "天" + lefth + "时" + leftm + "分" + lefts + '秒'; //返回倒计时的字符串
			},
			lasttime() {
				var times;
				times = document.querySelectorAll(".limit_time")
				var time = 0;
				for (var i = 0; i < times.length; i++) {
					time = parseInt(times[i].dataset.last_time);
					time--;
					if (time < 0) {
						time = 0;
						clearInterval(this.timer);
					}

					times[i].dataset.last_time = time;
					times[i].innerText = this.showtime(time);
				}


			},
			run() {
				this.timer = setInterval(() => {
					this.lasttime();
				}, 1000);
			},
			watch: {
				'$route'(to, from) {
					if (to.name === 'home_class') { //跳转的的页面的名称是"NewRecruit",这里就相当于我们listview页面，或者原始页面
						let savehdjkG = this.$store.state.savehdjhaY;
						//把在vuex里面的位置存入
						document.getElementById('gundong').scrollTop = savehdjkG
					}
				}
			},
			beforeRouteLeave(to, from, next) {
				//获取滚动条的高度
				let position = document.getElementById('gundong').scrollTop;
				//离开路由存起来
				if (position == null) position = 0
				this.$store.commit('savehdjkG', position) //离开路由时把位置存起来
				next()
			},
		},
	}
</script>

<style>
	.browsinghistory .block {
		margin-top: 2.5rem;
		width: 100%;
	}


	.browsinghistory .tiem {
		font-size: 16px;
		color: #999;
		text-align: left;
		width: 93%;
		margin: auto;

	}

	.browsinghistory .Delivery {
		margin-top: 0.625rem;
	}

	.browsinghistory .jilu {
		width: 100%;
		border-bottom: 1px solid #eee;
		background-color: #fff;
		padding: 1rem 0;
		position: relative;
		display: flex;
		justify-content: space-between;
	}

	.browsinghistory .browse_action {
		display: flex;
		width: 93%;
		margin: auto;
	}

	.browsinghistory .browse_action img {
		width: 5rem;
		height: 5rem;
		border-radius: 0.625rem;
		margin-left: 0.6rem;
		display: block;
	}

	.browsinghistory .type {
		width: 4.375rem;
		font-size: 0.75rem;
		color: #666;
		text-align: center;
		display: block;
		margin-top: 0.625rem;
		margin-left: -0.75rem;
	}

	.browsinghistory .browse_name {
		width: 100%;
		font-size: 0.8rem;
		text-align: left;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.browsinghistory .period {
		font-size: 0.75rem;
		text-align: left;
		color: #333;
	}

	.browsinghistory .Price {
		font-size: 0.75rem;
		color: red;
		position: absolute;
		bottom: 1.125rem;
		right: 0.9375rem;
	}

	.browsinghistory .search {
		margin-top: 0.25rem;
		display: flex;
		justify-content: space-between;
		height: 1.5625rem;
		position: relative;
		top: 0.3125rem;
	}

	.browsinghistory .van-checkbox {
		margin-left: 0.6rem;
	}

	.browsinghistory .iconsont {}

	.browsinghistory .icon>i {
		width: 20px;
	}

	.browsinghistory .settle {
		height: 3.2rem;
		width: 100%;
		background: #fff;
		position: fixed;
		bottom: 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 2rem;
		box-sizing: border-box;
		font-size: 0.7rem;
		z-index: 666;
	}

	.browsinghistory .settle .all {
		display: flex;
	}

	.browsinghistory .settle .all span {
		margin-left: 0.2rem;
	}

	.browsinghistory .settle .total {
		color: #f1452f !important;
		font-size: 1rem;
	}

	.browsinghistory .settle .settle_btn button {
		background: #f1452f;
		outline: none;
		border: 0;
		color: #fff;
		border-radius: 1rem;
		width: 5rem;
		height: 1.8rem;
	}

	.browsinghistory .settle .van-button {
		width: 40%;
	}
</style>



// WEBPACK FOOTER //
// src/components/browsinghistory/browsinghistory.vue